import { IUser } from 'app/containers/Authorization/slice/types';
import { IEnv } from 'app/containers/HiikoEnv/slice/types';
import { ICompany } from '../../Cultures/slice/types';

/* --- STATE --- */
export interface UserState {
  userList: {
    loading: boolean;
    list: IUserListItem[];
  };
  userDetails: {
    loading: boolean;
    user: IUserDetails | null;
    list: IUserCompaniesListItem[];
  };
  addUserForm: {
    isOpen: boolean;
    loading: boolean;
    type: 'add' | 'edit';
    userEmail: string;
    permissions?: IAccessRightsNumbers;
  };
  addUserCompanyForm: {
    isOpen: boolean;
    loading: boolean;
    type: 'edit' | 'add';
    permissions?: IAccessRightsNumbers;
    companyId?: number;
    companyName?: string;
  };
}
export interface ISimpleUser {
  id: number;
  name: string;
  lastName: string;
  email: string;
  phoneNr: string;
  registrationDate: string;
  companyCount: number;
  consultant: boolean;
}

export interface IUserWithCompanyCount extends IUser {
  companyCount: number;
}
export interface IUserListItem {
  id: number;
  name: string;
  lastName: string;
  email: string;
  phoneNr: string;
  registrationDate: string;
  companyCount: number;
  permissions?: IAccessRightsNumbers;
}
export interface IUserListResponseItem {
  id: number;
  name: string;
  lastName: string;
  email: string;
  phoneNr: string;
  registrationDate: string;
  companyCount: number;
  userHiikoEnvironmentPermissions: IUserListResponsePermissions | null;
}

interface IUserListResponsePermissions
  extends IHiikoEnvironmentAdministrationView {
  [key: string]: unknown;
}

export interface IUserDetails {
  id: number;
  name: string;
  lastName: string;
  email: string;
  phoneNr: string;
  registrationDate: string;
  companyCount: number;
}

export interface ISubmitRemoveUserFromEnvPayload {
  envId: number;
  userId: number;
}

export interface IUserCompaniesListItem {
  id: number;
  name: string;
  companyCode: string;
  city: string;
  companyOwnerEmail: string;
  hiikoEnvironmentOwnerEmail: string;
  userCompanyPermissions: IAccessRightsNumbers;
}

export interface IUserCompaniesListResponseItem {
  name: string;
  companyCode: string;
  city: string;
  companyOwnerEmail: string;
  hiikoEnvironmentOwnerEmail: string;
  userCompanyPermissions: {
    id: string;
    user: {
      id: number;
      name: string;
      lastName: string;
      email: string;
      phoneNr: string;
      registrationDate: string;
      companyCount: number;
    };
    company: {
      id: number;
      name: string;
      companyCode: string;
      city: string;
      accepted: null;
    };
  } & IHiikoEnvironmentAdministrationView;
}

export interface IUserInList extends IUser {
  companyCount: number;
}

export interface IGetUserListPayload {
  envId: number;
  companyId: number | null;
}

export interface IGetUserDetailsPayload {
  userId: number;
  envId: number;
}

export enum userListTableColEnum {
  name = 'name',
  email = 'email',
  companyCount = 'companyCount',
  actions = 'actions',
}

export enum RoleEnum {
  shared = 'SHARED',
}

export interface ISubmitAddUserFormPayload {
  envId: number;
  email: string;
  role: RoleEnum;
  permissions: IFormPermissions;
  type: 'add' | 'edit';
}

export interface ISubmitAddUserToCompanyPayload
  extends ISubmitAddUserFormPayload {
  companyId: number;
  userId: number;
}

export enum PermissionsEnum {
  companyAdministration = 'companyAdministration',
  cultureAdministration = 'cultureAdministration',
  fieldAdministration = 'fieldAdministration',
  resourceAdministration = 'resourceAdministration',
  taskAdministration = 'taskAdministration',
  recommendationPermission = 'recommendationPermission',
  usersAdministration = 'usersAdministration',
  garageAdministration = 'garageAdministration',
  analytics = 'analytics',
}

export interface IAccessRightsNumbers
  extends Required<Record<PermissionsEnum, 0 | 1 | 2>> {}

export interface IFormPermissions extends IAccessRightsNumbers {}

export interface IHiikoEnvironmentAdministrationView {
  companyAdministrationRead: boolean;
  companyAdministrationWrite: boolean;

  cultureAdministrationRead: boolean;
  cultureAdministrationWrite: boolean;

  fieldAdministrationRead: boolean;
  fieldAdministrationWrite: boolean;

  resourceAdministrationRead: boolean;
  resourceAdministrationWrite: boolean;

  taskAdministrationRead: boolean;
  taskAdministrationWrite: boolean;

  recommendationPermission: boolean;

  usersAdministrationRead: boolean;
  usersAdministrationWrite: boolean;

  garageAdministrationRead: boolean;
  garageAdministrationWrite: boolean;

  analyticsPermission: boolean;
}

interface IPermissionsByCompany extends IHiikoEnvironmentAdministrationView {
  id: string;
  user: ISimpleUser;
  company: ICompany;
}

export interface IHikosEnvPermissionsResponse
  extends IHiikoEnvironmentAdministrationView {
  id: number;
  user: ISimpleUser;
  hiikoEnvironment: IEnv;
  permissionsByCompany: IPermissionsByCompany[];
}

export interface ICreateOrUpdateUserCompanyData {
  administrationView: IHiikoEnvironmentAdministrationView;
  email: string;
  role: RoleEnum;
}

export interface ICreateOrUpdateUserHiikoEnvironmentData {
  email: string;
  hiikoEnvironmentAdministrationView: IHiikoEnvironmentAdministrationView;
  role: RoleEnum;
}
